import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import { AssignmentsStore, SubmissionsStore } from '@/store';
import * as utils from '@/utils';
import UserNotification from './UserNotification';
export default tsx.componentFactoryOf().create({
    name: 'inner-user-notifications',
    props: {
        /** The set of checked notification IDs. */
        checkedNotificationIds: p.ofType().required,
        /** The notifications to display. */
        notifications: p.ofType().required,
        /** Whether to show already read notifications. */
        showRead: p(Boolean).required,
        /** The load more button. */
        loadMoreNode: p.ofType().optional,
        /** The notification list ID used for accessibility. */
        notificationsTableId: p(String).required,
    },
    computed: {
        /** @returns The rows for the notifications table.  */
        tableRowsNode() {
            return this.notifications.map(notification => (<UserNotification key={notification.id} class={{
                    '!bg-neutral-2 dark:!bg-neutral-80': !!notification.read,
                    '!px-5': true,
                }} notification={notification} checked={this.checkedNotificationIds.includes(notification.id)} onToggleCheckbox={payload => tsx.emitOn(this, 'onToggleCheckbox', payload)}/>));
        },
        /** @returns The table of all notifications. */
        tableNode() {
            const notifications = this.notifications;
            if (notifications.length === 0) {
                return utils.emptyVNode();
            }
            return (<table id={this.notificationsTableId} aria-label="Notifications table" class={{
                    'table table-hover mb-0': true,
                }}>
                    <transition-group tag="tbody">{this.tableRowsNode}</transition-group>
                </table>);
        },
    },
    watch: {
        notifications: {
            immediate: true,
            /**
             * Loads the submissions and assignments for the associated notifications.
             *
             * @param notifications Notifications to load.
             */
            async handler(notifications) {
                if (notifications.length === 0) {
                    return;
                }
                const [assignmentIds, submissionIds] = [
                    new Set(notifications.map(n => n.assignmentId)),
                    new Set(notifications.map(n => n.workId)),
                ];
                await Promise.all([
                    ...Array.from(assignmentIds).map(id => AssignmentsStore.loadSingleAssignment({ assignmentId: id })),
                    ...Array.from(submissionIds).map(id => SubmissionsStore.loadSingleSubmission({ submissionId: id })),
                ]);
            },
        },
    },
    /** @returns The rendered notification node. */
    render() {
        return (<div class={[
                'user-notifications',
                'flex',
                'flex-col',
                'border-x',
                'border-b',
                'border-neutral-5',
                'dark:border-neutral-80',
                'overflow-y-auto',
                'rounded-b-lg',
            ]}>
                {this.tableNode}
                {this.loadMoreNode}
            </div>);
    },
});
